module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-delete-icon.a14daea5.svg";